var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"event-view-map-container"}},[(_vm.map)?_c('VueMapboxMap',{attrs:{"map":_vm.map,"interactive":true,"lng":_vm.event.longitude,"lat":_vm.event.latitude,"zoom":"11","pitch":"0","bearing":"0"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }